import request from '../utils/request'

//诊断数据列表
export function getDatas(query) {
  return request({
    url: '/diagdata/diagdata',
    method: 'get',
    params: query
  })
}

//查看诊断数据解析好的HTMl
export function getDataHtml(id) {
  return request({
    url: '/diagdata/viewdata/'+id,
    method: 'get',
    params: query
  })
}

//查看CSV数据
export function getCsvData(query) {
  return request({
    url: '/diagdata/csvdata',
    method: 'get',
	params: query
  })
}

//批量下载诊断数据
export function downloadData(data) {
  return request({
    url: '/diagdata/downloaddata',
    method: 'post',
    data,
	type: 'download'
	
  })
}

//删除数据
export function delData(id) {
  return request({
    url: '/diagdata/deldiagdata/'+id,
    method: 'delete',
  })
}

//新数据通知
export function getNewDatas(query) {
  return request({
    url: '/diagdata/newdata',
    method: 'get',
    params: query
  })
}